(function(angular){
    'use strict';

    angular.module('nucleus.dashboard').config(['$stateProvider', function($stateProvider){
        $stateProvider.state('firm-dashboard', {
            // url: '/dashboard/firm/:view',
            url: '/',
            templateUrl: 'dashboard/firm-dashboard.2js.html',
            controller: 'nucleus.dashboard.FirmDashboardController as vm',
            resolve: {
                landingPage: function isLandingPage() { return false;},
                authz: ['$state', 'bmPermission', 'bmAccess', function($state, bmPermission, bmAccess) {
                    return bmAccess.has('BR_OnvioStaffHomePage').then(function(){
                        return bmPermission.has('Applications.OnvioClientHub').then(function(){
                            $state.go('notfound');
                        }).catch(function(){
                            $state.go('dashboard-core-center', {}, { reload: true });
                        });
                    }).catch(function(){
                        return bmPermission.has('OnvioBR.StaffHomePage').then(function(){
                            return bmPermission.has('Applications.OnvioClientHub').then(function(){
                                $state.go('notfound');
                            }).catch(function(){
                                $state.go('dashboard-core-center', {}, { reload: true });
                            });
                        }).catch(function(){
                        return bmPermission.has('Applications.Onvio').catch(function(){
                            // if onvio docs basic app, go to all docs
                            bmPermission.hasEvery(['Applications.OnvioDocumentsBasic', 'OnvioDrive.Documents']).then(function(){
                                $state.go('allDocsRootList', {}, { reload: true });
                            }, function(){
                                // otherwise not found
                                $state.go('notfound');
                            });
                            });
                        });
                    });
                }],
                themeData: ['bmTheme', function(bmTheme){
                    // resolve here for background loading early
                    bmTheme.useTheme = true;
                    return bmTheme.load().then(function(){
                        return bmTheme.data;
                    });
                }],
                user: ['myAccountService', function(myAccountService){
                    return myAccountService.getMyUserSettingsAsync().then(function(settings){
                        return settings.data;
                    });
                }]
            },
            params: {
                dataQeId:'nucleus-dashboard-FirmDashboardController'
            }
        });
        $stateProvider.state('onvio-setup', {
            url: '/onvio-setup',
            onEnter: ['$uibModal', function($uibModal){
                $uibModal.open({
                    animation: true,
                    templateUrl: ('dashboard/landing-page-modal.html'),
                    controller: 'nucleus.dashboard.FirmDashboardController as vm',
                    resolve: {
                        landingPage: function isLandingPage() { return true;},
                        authz: ['$state', 'bmPermission', function($state, bmPermission) {
                            return bmPermission.has('Applications.Onvio').catch(function(){
                                // if onvio docs basic app, go to all docs
                                bmPermission.hasEvery(['Applications.OnvioDocumentsBasic', 'OnvioDrive.Documents']).then(function(){
                                    $state.go('allDocsRootList');
                                }, function(){
                                    // otherwise not found
                                    $state.go('notfound');
                                });
                            });
                        }],
                        themeData: ['bmTheme', function(bmTheme){
                            // resolve here for background loading early
                            bmTheme.useTheme = true;
                            return bmTheme.load().then(function(){
                                return bmTheme.data;
                            });
                        }],
                        user: ['myAccountService', function(myAccountService){
                            return myAccountService.getMyUserSettingsAsync().then(function(settings){
                                return settings.data;
                            });
                        }]
                    },
                    size: 'lg',
                    windowClass: 'setup-step-modal setup-landing-page-modal',
                    backdropClass: 'setup-landing-page-modal-backdrop'
                });
            }]
        });
        $stateProvider.state('dashboard-core-center', {
            url: '/dashboard-core-center',
            template: '<banking-staff-dashboard-wrapper></banking-staff-dashboard-wrapper>',
            resolve: {
              user: ['myAccountService', function(myAccountService){
                return myAccountService.getMyUserSettingsAsync().then(function(settings){
                  return settings.data;
                });
              }]
            }
        });

    }]);
})(window.angular);
